<ng-container *ngIf="!this._UserHelper?.isSignedIn">
  <ng-container [ngSwitch]="['wettarena', 'b500', 'terminalPeru', 'cangobet'] | getProductName">
    <ng-container *ngSwitchCase="'wettarena'">
      <login-wettarena-component></login-wettarena-component>
    </ng-container>
    <ng-container *ngSwitchCase="'b500'">
      <login-b500-component></login-b500-component>
    </ng-container>
    <ng-container *ngSwitchCase="'cangobet'">
      <login-cangobet-component></login-cangobet-component>
    </ng-container>
    <ng-container *ngSwitchCase="'terminalPeru'">
      <login-terminalPeru-component></login-terminalPeru-component>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <login-b3000-component></login-b3000-component>
    </ng-container>
  </ng-container>
</ng-container>
<div class="login-mobile text" *ngIf="this._UserHelper?.isSignedIn">
  <div class="sidenav-header">
    <div class="left">{{ this._UserHelper?.customerUser.UserName }}</div>
    <div class="right" (click)="closeSideBar()">
      <image-loader-utils url="close" extraClasses="close-icon"></image-loader-utils>
    </div>
  </div>
  <ng-container [ngSwitch]="['b500'] | getProductName">
    <ng-container *ngSwitchCase="'b500'"> </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="user-up-container">
        <div *ngFor="let item of this._UserHelper.walletList">
          <div
            class="shop-container"
            [ngClass]="{ 'bg-grey': item.CustomerId == this._UserHelper.customerUser?.CustomerId }"
            (click)="walletSelectChange(item)"
            style="display: flex; width: 100%">
            <div class="container-row">
              <div class="radio-input">
                <div class="radio-dot" [ngClass]="{ active: item.CustomerId == this._UserHelper.customerUser?.CustomerId }">
                  <div class="dot"></div>
                </div>
              </div>
              <div class="shop-name">
                <div class="up-text">{{ item.BranchType === 1 ? ('Web' | t) : item.BrancName }}</div>
              </div>
              <div class="balance">{{ item.Balance | balanceFormat }}</div>
            </div>
            <div class="container-row" style="height: 18px">
              <div class="radio-input"></div>
              <div class="down-text"></div>
              <!-- walletListten gelen state yazısı buraya gelecek container-row classtaki style kalkacak-->
            </div>
          </div>
        </div>

        <ng-container [ngSwitch]="['b500'] | getProductName">
          <ng-container *ngSwitchCase="'b500'"></ng-container>
          <ng-container *ngSwitchDefault>
            <div class="shop-container deposit-btn" (click)="OpenAccountMobile(2)">{{ 'Deposit' | t }}</div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
  <div class="mid-container">
    <div class="mid-container-row" (click)="OpenAccountMobile(1)">
      <div class="left-svg">
        <image-loader-utils url="file" extraClasses="svg-file-icon"></image-loader-utils>
      </div>
      <div class="mid">{{ 'betting_history' | t }}</div>
      <div class="right"></div>
    </div>
    <div class="mid-container-row" (click)="OpenAccountMobile(10)" *ngIf="this._UserHelper.customerUser.IsView === 'True'">
      <div class="left-svg">
        <image-loader-utils url="coins" extraClasses="creditworthiness"></image-loader-utils>
      </div>
      <div class="mid">
        <ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
          <ng-container *ngSwitchCase="'wettarena'"> ArenaPay </ng-container>
          <ng-container *ngSwitchCase="'b500'"> ArenaPay </ng-container>
          <ng-container *ngSwitchDefault> PAY3000 </ng-container>
        </ng-container>
      </div>
      <div class="right"></div>
    </div>
    <div class="mid-container-row" (click)="userDropdownOpen()">
      <div class="left-svg">
        <image-loader-utils url="account" extraClasses="svg-account-icon"></image-loader-utils>
      </div>
      <div class="mid">{{ 'MyAccount' | t }}</div>
      <div class="right">
        <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (userDropdownIsOpen ? 'up' : 'down')"></image-loader-utils>
      </div>
    </div>
    <div class="drop-down-mobile-menu" [ngClass]="{ displayShow: userDropdownIsOpen }">
      <account-menu-component menuSelect="rightMenu" [userHelper]="this._UserHelper" [UiHelper]="this._UiHelper"></account-menu-component>
    </div>

    <ng-container [ngSwitch]="['b500', 'cangobet'] | getProductName">
      <ng-container *ngSwitchCase="'b500'">
        <div class="mid-container-row" (click)="OpenAccountMobile(5)">
          <div class="left-svg">
            <image-loader-utils url="password" extraClasses="svg-logout-icon"></image-loader-utils>
          </div>
          <div class="mid">{{ 'ChangePassword' | t }}</div>
          <div class="right"></div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'cangobet'">
        <div class="mid-container-row" (click)="OpenAccountMobile(5)">
          <div class="left-svg">
            <image-loader-utils url="password" extraClasses="svg-logout-icon"></image-loader-utils>
          </div>
          <div class="mid">{{ 'ChangePassword' | t }}</div>
          <div class="right"></div>
        </div>
      </ng-container>

      <ng-container *ngSwitchDefault> </ng-container>
    </ng-container>

    <div class="mid-container-row" (click)="SignOutDialogOpener(true)">
      <div class="left-svg">
        <image-loader-utils url="logout" extraClasses="svg-logout-icon"></image-loader-utils>
      </div>
      <div class="mid">{{ 'right_menu_sign_out' | t }}</div>
      <div class="right"></div>
    </div>
    <ng-container [ngSwitch]="['wettarena'] | getProductName">
      <ng-container *ngSwitchCase="'wettarena'">
        <div class="mid-container-row" [routerLink]="['/scanner/scan']">
          <div class="left-svg">
            <image-loader-utils url="scanner-barcode" extraClasses="svg"></image-loader-utils>
          </div>
          <div class="mid">{{ 'RIGHT_MENU.SLIP_CHECK' | t }}</div>
          <div class="right"></div>
        </div>
        <div class="mid-container-row" [routerLink]="['/scanner/scan']">
          <div class="left-svg">
            <image-loader-utils url="scanner-qr" extraClasses="svg"></image-loader-utils>
          </div>
          <div class="mid">{{ 'RIGHT_MENU.TERMINAL_LOGIN' | t }}</div>
          <div class="right"></div>
        </div>
      </ng-container>
    </ng-container>
    <div class="mid-container-row">
      <div class="left">{{ 'last_login' | t }}</div>
      <div class="mid last-login-date">
        {{ this._UserHelper?.customerUser.LastLoginDate | dateFormat : 'dd-MM-yyyy hh:mm a' }}
      </div>
    </div>
  </div>
</div>
<div class="switch-container" [ngClass]="{ 'sign-in': this._UserHelper?.isSignedIn }">
  <ng-container *ngIf="'isDarkMode' | getEnv">
    <div class="switch-row">
      <div class="switch-text">{{ 'dark_mode' | t }}</div>
      <div class="switch-select">
        <mat-slide-toggle color="primary" (click)="changeTheme()" checked="{{ this._UiHelper.currentTheme === 'theme-dark' }}"></mat-slide-toggle>
      </div>
    </div>
  </ng-container>
  <div class="switch-row">
    <div class="switch-text">{{ 'quick_bet' | t }}</div>
    <div class="switch-select">
      <mat-slide-toggle color="primary" (click)="changeQuickTipp()" checked="{{ quickTippChecked }}"></mat-slide-toggle>
    </div>
  </div>
  <language-dropdown-component></language-dropdown-component>
</div>
